/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_2Nq7ma5Pp",
    "aws_user_pools_web_client_id": "7og89dcfj1is6fvuvlofmi6a7g",
    "oauth": {
        "domain": "prodlemonadefashion.auth.us-west-2.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "phone"
        ],
        "redirectSignIn": "https://cms.joinpipp.com/,https://cms.lemonadefashion.com/,https://joinpipp.com,https://joinpipp.com/,https://lemonadefashion.app.link,https://lemonadefashion.app.link/,https://lemonadefashion.com,https://lemonadefashion.com/,https://portal.joinpipp.com/,https://portal.lemonadefashion.com/,lemonadefashion://,lemonadefashion://open",
        "redirectSignOut": "https://cms.joinpipp.com/,https://cms.lemonadefashion.com/,https://joinpipp.com/logout,https://lemonadefashion.app.link,https://lemonadefashion.app.link/,https://lemonadefashion.com/logout,https://portal.joinpipp.com/,https://portal.lemonadefashion.com/,lemonadefashion://,lemonadefashion://open",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE",
        "APPLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "GIVEN_NAME",
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
